import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';
import { useEffect, useRef } from 'react';

function closestPolyfill(window) {
    const ElementPrototype = window.Element.prototype;

    if (typeof ElementPrototype.matches !== 'function') {
        ElementPrototype.matches =
            ElementPrototype.msMatchesSelector ||
            ElementPrototype.mozMatchesSelector ||
            ElementPrototype.webkitMatchesSelector ||
            function matches(selector) {
                let element = this;
                const elements = (element.document || element.ownerDocument).querySelectorAll(selector);
                let index = 0;

                while (elements[index] && elements[index] !== element) {
                    ++index;
                }

                return Boolean(elements[index]);
            };
    }

    if (typeof ElementPrototype.closest !== 'function') {
        ElementPrototype.closest = function closest(selector) {
            let element = this;

            while (element && element.nodeType === 1) {
                if (element.matches(selector)) {
                    return element;
                }

                element = element.parentNode;
            }

            return null;
        };
    }
}
closestPolyfill(window);

let locks = 0;

function useBodyScrollLock() {
    const ref = useRef(null);
    useEffect(() => {
        disableBodyScroll(ref.current, {
            // tuto triedu je potrebne pridat k elementom nachadzajucim sa v dialogoch, ktore nejakym sposobom vyuzivaju scroll, swipe (napr, horizontalny)
            allowTouchMove: el => Boolean(el.closest('.body-scroll-lock-ignore'))
        });
        locks++;

        return () => {
            locks--;
            if (locks <= 0) {
                clearAllBodyScrollLocks();
            }
        };
    }, []);

    return ref;
}

export default useBodyScrollLock;
